import { render, staticRenderFns } from "./FamilyPatentsList.vue?vue&type=template&id=948be4a6"
import script from "./FamilyPatentsList.vue?vue&type=script&setup=true&lang=ts"
export * from "./FamilyPatentsList.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FamilyPatentsList.vue?vue&type=style&index=0&id=948be4a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports